"use client";

import Image from "next/image";
import { forwardRef, useState } from "react";

type FileInputProps = {
  label: string;
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
  children?: React.ReactNode;
};

const FileInput = forwardRef<HTMLInputElement, FileInputProps>((props, ref) => {
  const { name, onChange, accept, children } = props as FileInputProps;
  const [file, setFile] = useState<File | null>(null);
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFile(e.target.files?.[0] || null);
    if (onChange) {
      onChange(e);
    }
  };
  return (
    <div className="flex items-center justify-center w-full relative bg-gray-50  hover:bg-gray-100">
      <label
        htmlFor="fileDrop"
        className="z-10 flex flex-col items-center justify-center w-full h-28 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer "
      >
        <div className="flex flex-col items-center justify-center pt-5 pb-6">
          <svg
            className="w-8 h-8 mb-4 text-gray-500 "
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 16"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
            />
          </svg>
          {file && (
            <p className="mb-2 text-sm text-gray-500 text-center">
              <span className="font-semibold">{file.name}</span> selected.
            </p>
          )}
          <p className="mb-2 text-sm text-gray-500 text-center">
            {!file && (
              <>
                <span className="font-semibold">Click to upload a logo</span> or
                drag and drop it
              </>
            )}
            {file && (
              <>
                Click or drag and drop a new image{" "}
                <span className="font-semibold">to replace it</span>
              </>
            )}
          </p>
          <p className="text-xs text-gray-500 ">
            SVG, PNG or JPG (MAX. 800x400px)
          </p>
          {children}
        </div>
        <input
          id="fileDrop"
          type="file"
          name={name}
          ref={ref}
          className="hidden"
          onChange={handleOnChange}
          accept={accept}
        />
      </label>
      {file && (
        <div className="absolute inset-0 rounded-lg overflow-hidden">
          <Image
            src={URL.createObjectURL(file)}
            alt="selected"
            layout="fill"
            objectFit="cover"
            className="opacity-50"
          />
          <div className="absolute inset-0 bg-white bg-opacity-50 backdrop-blur-md"></div>
        </div>
      )}
    </div>
  );
});

FileInput.displayName = "FileInput";

export default FileInput;
